import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { getResponses } from "../../services/clients";
import ResponsesTable from "../../components/Tables/ResponsesTable";

export const Responses = () => {
  const { selectedClient } = useContext(AppContext);
  const [responses, setResponses] = useState([]);

  useEffect(() => {
    const fetchResponses = async () => {
      try {
        setResponses(
          await getResponses(selectedClient.public_id ?? selectedClient.id)
        );
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT FROM users: ", selectedClient);
    if (selectedClient) {
      fetchResponses();
    }
    // eslint-disable-next-line
  }, [selectedClient]);
  return (
    <div>
      <ResponsesTable responses={responses} />
    </div>
  );
};

export default Responses;
